export default [
  {
    value: 'enterprise',
    label: 'Enterprise Activation',
  },
  {
    value: 'member',
    label: 'Member Activation ',
  },
  {
    value: 'plan',
    label: 'Plan Activation ',
  },
];
